import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

const CLAIM_NO_MISSING = 'Claim Number is missing';

@Injectable({
  providedIn: 'root',
})
export class KbFileFLCService {
  filesSubjectFLC: BehaviorSubject<File[]> = new BehaviorSubject([]);
  filesFLC$: Observable<File[]> = this.filesSubjectFLC.asObservable();

  constructor(protected occEndpointsService: OccEndpointsService, protected http: HttpClient, private logger: NGXLogger) { }

  addFile(file: File): void {
    const currentFiles = this.filesSubjectFLC.getValue();
    const updatedFiles = [...currentFiles, file];
    this.filesSubjectFLC.next(updatedFiles);
  }

  deleteFile(fileName: string): void {
    const currentFiles = this.filesSubjectFLC.getValue();
    const updatedFiles = currentFiles.filter((file) => file.name !== fileName);
    this.filesSubjectFLC.next(updatedFiles);
  }

  getCurrentFileCount(): Observable<number> {
    return this.filesFLC$.pipe(map((filesFLC) => filesFLC.length));
  }
  getCurrentFilesInfo(): Observable<{ name: string; size: number }[]> {
    return this.filesFLC$.pipe(map((filesFLC) => filesFLC.map((file) => ({ name: file.name, size: file.size / 1024 }))));
  }
  isNotDuplicate(fileName: string): boolean {
    const currentFiles = this.filesSubjectFLC.getValue();
    return !currentFiles.some((file) => file.name === fileName);
  }
  getAllFiles(): File[] {
    return this.filesSubjectFLC.getValue();
  }
  isFileSizeLessThan9MB(file: File): boolean {
    return file.size <= 9 * 1024 * 1024;
  }

  isTotalFileSizeLessThan9MB(): boolean {
    const totalSize = this.filesSubjectFLC.getValue().reduce((acc, file) => acc + file.size, 0);
    return totalSize <= 9 * 1024 * 1024;
  }

  isAtLeastOneFilePresent(): boolean {
    return this.filesSubjectFLC.getValue().length > 0;
  }

  uploadTheFilesOnebyOne(claimNumber): Observable<any> {
    try {
      const filesMap = this.filesSubjectFLC.getValue();
      if (!claimNumber) {
        this.logger.error(CLAIM_NO_MISSING);
        console.error(CLAIM_NO_MISSING);
        return throwError(() => new Error(CLAIM_NO_MISSING));
      }
      const formData = new FormData();
      formData.append('claimNumber', claimNumber);
      filesMap.forEach((file) => {
        formData.append('file', file || null);
      });
      const loggableData = {};
      formData.forEach((value, key) => {
        loggableData[key] = value instanceof File ? value.name : value;
      });
      this.logger.info("FormData contents:", loggableData);
      return this.uploadFiles(formData);
    }
    catch (error) {
      this.logger.error('An error Occured in the file upload process: ', error);
      return throwError(() => error);
    }
  }
  uploadFiles(payLoad: FormData): Observable<any> {
    const url = this.occEndpointsService.buildUrl('mywarranty/submitNaAttachments');
    return this.http.post(url, payLoad);
  }

  clearAllFiles() {
    this.filesSubjectFLC.next([]);
  }

  getLastFileName(): string | null {
    const currentFiles = this.filesSubjectFLC.getValue();
    return currentFiles.length > 0 ? currentFiles[currentFiles.length - 1].name : null;
  }
}
